export const environment = {
  production: false,
  apiUrl: 'https://backend.nobissalud.com/',
  gecrosUrl: 'https://appmobile.nobissalud.com.ar/',
  meiliSearchUrl: 'https://meilisearch.nobissalud.com/',
  meiliSearchKey: '1e2604320611f3959646b1eb5a82cb2dc8d90263344e4c9df0d47a65e390b12a',
  meiliSearchIndex: 'nobis-medical-providers',
  meiliSearchStudiesIndex: 'nobis-medical-studies',
  firebase: {
    apiKey: 'AIzaSyB5FItiMLPeue1rh2dRITwGYXAFGHT8sDI',
    authDomain: 'app-nobis-509515.firebaseapp.com',
    projectId: 'app-nobis-509515',
    storageBucket: 'app-nobis-509515.firebasestorage.app',
    messagingSenderId: '891941143224',
    appId: '1:891941143224:web:a733ccb0111e0f13d4ea4d',
    measurementId: 'G-V8TEPS023X',
  },
  // Opcional: vacío usa la clave pública por defecto de Firebase. Si se completa, debe ser la del proyecto de arriba.
  firebaseVapidKey: '',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
